import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import Keycloak from 'keycloak-js';
import { sanitizeReturnUrl } from './return-url';

export const requireAuthenticatedGuard: CanActivateFn = (_route, state) => {
  const keycloak = inject(Keycloak);
  const router = inject(Router);

  if (keycloak.authenticated) {
    return true;
  }

  // Il return url viaggia nella query string e da lì nel `redirectUri` OAuth
  // (vedi `buildPostLoginRedirectUri`), non in `localStorage`: il magic link di
  // firma viene spesso aperto dalla webview di un client di posta, mentre il
  // login si completa in un browser che non ne condivide lo storage. Con il
  // return url conservato lato browser quel giro perdeva il `?token=…` e
  // l'approvatore atterrava sulla dashboard senza nulla da firmare.
  const returnUrl = sanitizeReturnUrl(state.url);

  return router.createUrlTree(
    ['/home'],
    returnUrl ? { queryParams: { returnUrl } } : {},
  );
};
